module.exports = __webpack_public_path__ + "d70ed8494f0f67b83a70063a96c83282.jpg";


//////////////////
// WEBPACK FOOTER
// ./app/containers/StaticPage/ComeBack/assets/sec-5/reviews-section-5/review-3.jpg
// module id = ./app/containers/StaticPage/ComeBack/assets/sec-5/reviews-section-5/review-3.jpg
// module chunks = 40